<template>
  <div class="left-outer">
    <DataOverview />
    <TradeRanking />
    <DataAnalysis />
  </div>
</template>

<script>
import DataAnalysis from './DataAnalysis.vue'
import DataOverview from './DataOverview/index.vue'
import TradeRanking from './TradeRanking.vue'

export default {
  components:{
    DataAnalysis,
    DataOverview,
    TradeRanking,
  }
}
</script>

<style lang="scss" scoped>
.left-outer{
  width: 460px;
  flex-shrink: 0;
  padding: 10px 15px;
  box-sizing: border-box;
  background-color: #021B4C;
  box-shadow: 0px 0px 10px 2px #1F4E8A inset;
  margin-bottom: 8px;
}
</style>